import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/styles.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import PlayerProvider from './context/PlayerContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <PlayerProvider>
        <Router>
            <App />
        </Router>
    </PlayerProvider>
);